import { CUSTOM_EVENTS } from './constants'

// Marks our push wrapper so the proxy can be re-applied (e.g. after GTM's gtm.js
// loads and replaces dataLayer.push) without double-wrapping an existing one.
const DL_PROXY_TAG = '__lbDlProxy'

/**
 * Wrap window.dataLayer.push so every push dispatches a DATA_LAYER_CHANGE event
 * (the only bridge from Attentive's dataLayer pushes to internal-analytics events).
 *
 * Idempotent + re-appliable: GTM's gtm.js reassigns dataLayer.push when it loads,
 * discarding our wrapper. Callers re-run this once GTM has taken over so our
 * wrapper sits on top of GTM's push again (mirrors the SSR-GTM ordering on US/CA).
 * If the current push is already our wrapper, this no-ops to avoid double-dispatch.
 */
function initialiseDlProxy() {
  window.dataLayer = window.dataLayer || []

  const currentPush = window.dataLayer.push as typeof window.dataLayer.push & { [DL_PROXY_TAG]?: boolean }
  if (currentPush[DL_PROXY_TAG]) return

  const handler = {
    apply: function (target: any, thisArg: any, argumentsList: any) {
      const result = Reflect.apply(target, thisArg, argumentsList)
      document.dispatchEvent(
        new CustomEvent(CUSTOM_EVENTS.DATA_LAYER_CHANGE, {
          detail: argumentsList,
        }),
      )
      return result
    },
  }

  const proxied = new Proxy(currentPush.bind(window.dataLayer), handler) as typeof window.dataLayer.push & {
    [DL_PROXY_TAG]?: boolean
  }
  proxied[DL_PROXY_TAG] = true
  window.dataLayer.push = proxied
}

export default initialiseDlProxy
